import { ErrorType21 } from './ErrorType21';
import { FailureKind } from '../../../../FailureKind';
import { NetworkTransport } from '../../../../NetworkTransport';

/**
 * app_error_shown
 * Показ ошибки пользователю. Событие отправляется, когда пользователю показывается ошибка (snackbar, toast, alert, полноэкранная ошибка и т.д.).
 */
export interface AppErrorShownV2 {
  /**
   * Machine-readable код ошибки (например: connect, socket_timeout, http_500, waf_ban). Опционально
   */
  error_code?: string;

  /**
   * Техническое описание от BE/API/throwable, не показываемое пользователю. Опционально
   */
  error_description?: string;

  /**
   * Текст ошибки, показанный пользователю
   */
  error_message: string;

  /**
   * Источник ошибки в приложении (например: loyalty_categories, missions_load, card_refresh). Опционально
   */
  error_origin?: string;

  error_type: ErrorType21;

  failure_kind?: FailureKind;

  /**
   * Есть ли активная сеть по ConnectivityManager в момент ошибки. Опционально
   */
  has_network?: boolean;

  /**
   * NET_CAPABILITY_VALIDATED — подтверждённый доступ в интернет. Опционально
   */
  is_network_validated?: boolean;

  /**
   * Активен ли VPN-транспорт в момент ошибки. Опционально
   */
  is_vpn_active?: boolean;

  network_transport?: NetworkTransport;

  /**
   * Название экрана, где показана ошибка
   */
  screen_name: string;
}

export function mapAppErrorShownV2Event(event: AppErrorShownV2): object {
  const props: Record<string, unknown> = {
      error_code: event.error_code,
      error_description: event.error_description,
      error_message: event.error_message,
      error_origin: event.error_origin,
      error_type: event.error_type,
      failure_kind: event.failure_kind,
      has_network: event.has_network,
      is_network_validated: event.is_network_validated,
      is_vpn_active: event.is_vpn_active,
      network_transport: event.network_transport,
      screen_name: event.screen_name,
  };

  return {
    event: 'analytics_event',
    event_name: 'app_error_shown',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
